// removed by extract-text-webpack-plugin
module.exports = {"trip-image":"_3f_RcmX8exEgmLnHoRTnEt","trip-content":"_3U-DfJDDm1h2cl6KOfiOqs","trip-name":"_1u0_qUyrLAezuwvUPCHriV","trip-rating-container":"_1g0wbfVBH1n2IbXWYLqw3n","trip-footer":"_15OhQEkAgraIMr5dvKiVH9","review-count":"_2E9E8abLdLQI3eMxoCVX_g","price":"_3qLgG-sCJs97CXTYhXALWa","price-price":"_3_lF2RZq__cu5Op0Gxpb5C","price-per-person":"_1pHrLEDZVwEp2B34yaUHf"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Trip/ZHTrip.scss
// module id = 126
// module chunks = 1 2 9 13 14 24